/**
 * BotConfig Entity Definition
 */
import { z } from "zod";
import { AccountMovementSchema, BotStatisticsSchema, BotStatsSchema, PerformancePointSchema, PeriodicalStatsSchema, } from "../schemas/bot-config.schemas";
import { BotConfigRelationSchema } from "../schemas/relations";
import { BotWarningEntityDef } from "./bot-warning.entity";
import { ChargeEntityDef, RefundEntityDef } from "./charge.entity";
import { defineEntity } from "./core";
import { ExchangeAccountEntityDef } from "./exchange-account.entity";
import { getLazyUserEntityDef } from "./lazy-refs";
import { StrategyEntityDef } from "./strategy.entity";
import { SubscriptionEntityDef } from "./subscription.entity";
import { TradeEntityDef } from "./trade.entity";
// BotStats entity
const BotStatsEntityDef = defineEntity({
    name: "bot-stats",
    schema: BotStatsSchema,
    relations: {},
});
// Statistics entities for nested populate
const PerformanceHistoryEntityDef = defineEntity({
    name: "performance-history",
    schema: z.object({ history: z.array(PerformancePointSchema) }),
    relations: {},
});
const PeriodicalStatsEntityDef = defineEntity({
    name: "periodical-stats",
    schema: z.object({ periodicalStats: PeriodicalStatsSchema }),
    relations: {},
});
// BotStatistics entity
const BotStatisticsEntityDef = defineEntity({
    name: "bot-statistics",
    schema: BotStatisticsSchema,
    relations: {
        history: { type: "many", entity: () => PerformanceHistoryEntityDef },
        periodicalStats: { type: "one", entity: () => PeriodicalStatsEntityDef },
    },
});
// AccountMovement entity
const AccountMovementEntityDef = defineEntity({
    name: "account-movement",
    schema: AccountMovementSchema,
    relations: {},
});
// Extra fields schema for BotConfig
const BotConfigExtraFieldsSchema = z.object({
    userConfig: z.record(z.string(), z.unknown()).nullish(),
});
export const BotConfigEntityDef = defineEntity({
    name: "bot-config",
    schema: BotConfigRelationSchema.merge(BotConfigExtraFieldsSchema),
    relations: {
        accountMovements: { type: "many", entity: () => AccountMovementEntityDef },
        exchange_account: { type: "one", entity: () => ExchangeAccountEntityDef, nullable: true },
        strategy: { type: "one", entity: () => StrategyEntityDef },
        subscription: { type: "one", entity: () => SubscriptionEntityDef, nullable: true },
        trades: { type: "many", entity: () => TradeEntityDef },
        charges: { type: "many", entity: () => ChargeEntityDef },
        refunds: { type: "many", entity: () => RefundEntityDef },
        warnings: { type: "many", entity: () => BotWarningEntityDef },
        user: { type: "one", entity: getLazyUserEntityDef },
        stats: { type: "one", entity: () => BotStatsEntityDef, nullable: true },
        statistics: { type: "one", entity: () => BotStatisticsEntityDef },
    },
});
// Re-export internal entities
export { AccountMovementEntityDef, BotStatisticsEntityDef, BotStatsEntityDef };
